module.exports = __webpack_public_path__ + "static/logo.b40f9f35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/logo.svg
// module id = 19
// module chunks = 35783957827783 55213770944713 173894859265406 181753073384772